import * as React from 'react';
import styled from 'styled-components';
import { colors } from './colors/color';

type InputMessageProps = {
    inErrorState?: boolean,
    reserveSpace?: boolean,
    children: React.ReactNode,
    indent?: boolean;
};

// Will always reserve space for the message, even if it's empty.

export function InputMessage (props: InputMessageProps): JSX.Element
{
    return (
        <>
            <StyledDiv inErrorState={props.inErrorState === true} indent={props.indent || false}>
                {props.children}
            </StyledDiv>
        </>
    );
}

const StyledDiv = styled.div<{ inErrorState: boolean, indent: boolean; }>`
    
    ${props => props.inErrorState && "margin: 4px 16px"};
    font-size:14px;
    font-weight: 400;
    line-height: 20px;
    min-height: 20px;
    color:${props => props.inErrorState ? colors.text.state.error : colors.text.normal};
    padding-left: ${props => props.indent ? '16px' : '0px'};
`;